<template>
  <div class="error-management">
    <div class="current-error" v-for="(err, idx) in errorQueue" :key="idx">
      <details>
        <summary class="error-custom-message">{{ err.customMessage }}</summary>
        <dl>
          <div v-if="err.errorStatus">
            <dt>Status:</dt>
            <dd>{{ err.errorStatus }}</dd>
          </div>
          <div v-if="err.errorData.message">
            <dt>Message:</dt>
            <dd>{{ err.errorData.message }}</dd>
          </div>
          <div v-if="err.errorData.errorMessage">
            <dt>Erreur:</dt>
            <dd>{{ err.errorData.errorMessage }}</dd>
          </div>
          <div v-if="err.errorMessage">
            <dt>Message:</dt>
            <dd>{{ err.errorMessage }}</dd>
          </div>
        </dl>
      </details>
      <div class="error-actions">
        <button @click="closeError(idx)">Fermer</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorManager",

  computed: {
    errorQueue() {
      return this.$store.getters.errors;
    },
  },

  methods: {
    closeError(idx) {
      this.$store.dispatch("delete_error_from_queue", idx);
    },
  },
};
</script>

<style scoped>
button {
  border: 1px solid lightcoral;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}

button:hover {
  background: lightcoral;
  color: white;
}

dl > div {
  display: flex;
  margin-top: 0.5rem;
}

dt {
  margin-right: 0.5rem;
  font-weight: bold;
}
.error-management {
  position: fixed;
  right: 0;
  z-index: 2000;
}

.current-error {
  font-family: sans-serif;
  font-size: 0.8rem;
  position: relative;
  margin: 1rem;
  padding: 1rem;
  max-width: 600px;
  border-left: 6px solid red;
  background: rgb(255, 255, 255);
  color: lightcoral;
  -webkit-box-shadow: 5px 5px 15px -2px rgba(186, 186, 186, 0.86);
  box-shadow: 5px 5px 15px -2px rgba(186, 186, 186, 0.86);
  opacity: 0.8;
  animation-name: error-in;
  animation-duration: 0.5s;
}

.current-error:hover {
  opacity: 1;
}

.error-actions {
  display: flex;
  gap: 1rem;
  margin: 1rem 0 0 0;
  justify-content: flex-end;
}

.error-custom-message {
  font-weight: bold;
  font-size: 0.8rem;
}

@keyframes error-in {
  0% {
    right: -650px;
  }
  100% {
    right: 0px;
  }
}
</style>
